export const HttpConstants = {
  Authorization: 'Authorization',
  CacheIntercept: 'Cache-Intercept'
};
